import { render, staticRenderFns } from "./CharacterArt.vue?vue&type=template&id=57066839&scoped=true&"
import script from "./CharacterArt.vue?vue&type=script&lang=js&"
export * from "./CharacterArt.vue?vue&type=script&lang=js&"
import style0 from "./CharacterArt.vue?vue&type=style&index=0&id=57066839&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57066839",
  null
  
)

export default component.exports